import { Injectable, signal } from '@angular/core';

export interface PageTitleItem {
  label: string;
  value: number;
}

export interface PageTitleConfig {
  text: string;
  tooltipText?: string;
  hasDropdown?: boolean;
  showInlineTabs?: boolean;
  items?: PageTitleItem[];
  selectedIndex?: number;
  deliverableTitle?: string;
  onTabChange?: (index: number) => void;
  showViewModeToggle?: boolean;
}

export type DeliverableProfileKind = 'Document' | 'Tag Index' | 'Interface Index' | '3D Model';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  readonly PROJECT_SETUP_PREFIX = 'Project setup';
  readonly title = signal<PageTitleConfig | null>(null);

  set(title: string) {
    this.title.set({ text: title });
  }

  setProjectPage(pageName: string) {
    this.title.set({
      text: `${this.PROJECT_SETUP_PREFIX} - ${pageName}`,
    });
  }
  setDeliverableProfilePage(
    deliverableId: string | null | undefined,
    uniqueLabel: string | null | undefined,
    profileKind?: DeliverableProfileKind,
    // keep optional third parameter for backward compatibility; we ignore it intentionally
    _deliverableTitle?: string | null,
  ) {
    const normalizedDeliverableLabel = (deliverableId || uniqueLabel)?.trim() || '';
    const suffix = profileKind ? ` (${profileKind})` : '';

    this.title.set({
      text: `${normalizedDeliverableLabel}${suffix}`.trim(),
    });
  }

  setWorksheetTitle(deliverableLabel: string | null | undefined, showViewModeToggle = false): void {
    const label = deliverableLabel?.trim();
    if (!label) {
      return;
    }
    this.title.set({
      text: label,
      showViewModeToggle,
    });
  }
  setPageWithDropdown(
    pageName: string,
    items: PageTitleItem[],
    selectedIndex: number,
    onTabChange: (index: number) => void,
    showInlineTabs = false,
  ) {
    this.title.set({
      text: pageName,
      hasDropdown: true,
      ...(showInlineTabs ? { showInlineTabs: true } : {}),
      items,
      selectedIndex,
      onTabChange,
    });
  }

  clear() {
    this.title.set(null);
  }
}
